module.exports = __webpack_public_path__ + "media/images/icon_crown_green-86fd84f0f0ec7ffd696fd804c3347342.svg";